export const BRAND_NAME = "National Scoliosis Clinic";
export const BRAND_SHORT_NAME = "NSC";
export const BRAND_FULL_NAME = `${BRAND_NAME} (${BRAND_SHORT_NAME})`;
export const BRAND = {
  get NAME() {
    return BRAND_NAME;
  },
  get SHORT_NAME() {
    return BRAND_SHORT_NAME;
  },
  get FULL_NAME() {
    return BRAND_FULL_NAME;
  },
  get LEGAL_NAME() {
    return `${BRAND_NAME} Inc.`;
  },
};

export const BASE_URL = process.env.REACT_APP_API_URL;
